"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButton = exports.CSS = void 0;
exports.view = view;
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const icon_1 = require("../icon");
const theme_1 = require("../theme");
const MDL = {
    container: 'mdl-button mdl-button--icon'
};
exports.CSS = {
    container: 'c-Button',
    flip: 'c-Button--flip',
    isSmall: 'c-Button--is-small',
    icon: 'c-Button--icon'
};
const smallSize = theme_1.DefaultTheme.space(6);
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        userSelect: 'none',
        color: theme_1.DefaultTheme.font.color.supporting,
        // Overwrite MDL '!important' so 'a' tag does not default to a text cursor on hover
        ['&[disabled]:hover']: {
            cursor: 'default !important'
        }
    },
    [exports.CSS.flip]: {
        transform: 'translate(-12px,-12px) rotate(-90deg) !important'
    },
    [exports.CSS.isSmall]: {
        width: smallSize,
        height: smallSize,
        'min-width': smallSize,
        'min-height': smallSize,
        'font-size': '80%'
    },
    [exports.CSS.icon]: {
        'background-color': 'transparent'
    }
});
function view(icon, ctx = {}) {
    const href = ctx.href ? services_1.Services.Route.getRouteURL(ctx.href, ctx.hrefParams) : undefined;
    const extraClassName = ctx.className != null ? ctx.className : '';
    const isMaterialIcon = typeof icon === 'string';
    const title = ctx.title != null ? (0, i18n_1.Translate)(ctx.title, ctx.titleAttrs) : '';
    return (0, mithril_1.m)(ctx.type || 'a', Object.assign(Object.assign({ className: `${MDL.container} ${exports.CSS.container} ${extraClassName != null ? extraClassName : ''}`, id: ctx.id }, (ctx.disabled && { disabled: ctx.disabled })), { title,
        href, onclick: ctx.disabled ? undefined : ctx.onclick }), isMaterialIcon ? icon_1.Icon.view(icon, { className: exports.CSS.icon + ' ' + (ctx.flip ? exports.CSS.flip : '') }) : icon);
}
exports.ImageButton = { view, CSS: exports.CSS };
//# sourceMappingURL=image.button.js.map